import { useEffect, useState } from 'react'

export const useOnScreen = (
  ref: React.RefObject<HTMLElement | null>,
  rootMargin = '0px',
  threshold: number | number[] | undefined = 0,
  defaultValue = false
) => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(defaultValue)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)
      },
      {
        rootMargin,
        threshold,
      }
    )
    const current = ref.current
    if (current) {
      observer.observe(current)
    }

    return () => {
      if (current) {
        observer.unobserve(current)
      }
    }
  }, [ref, rootMargin, threshold])

  return isIntersecting
}
